import { useContext } from 'react';
import CacheContext from 'src/context/CacheContext';

export default function useCache() {
  const { getFromCache, saveToCache, clearCache } = useContext(CacheContext);

  return { getFromCache, saveToCache, clearCache };
}
